import Product from './pages/product/product';
import Carousel from './components/carousel';
import AddToWishlist from './pages/product/wishlist';
import NotifyMe from './pages/product/notifyMe';

document.addEventListener('DOMContentLoaded', (e) => {
  new Product().init();
  new Carousel().init();
  new AddToWishlist().init();
  new NotifyMe().init();
});
